import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import { TimeInput, toMoment } from '@core/utils/time';
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from 'moment';
import React, { Fragment, useCallback } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { FormGroup, Label } from 'reactstrap';
import './form_date.scss';
import { TimePicker, TimePickerProps } from 'antd';
import dayjs from 'dayjs';

export interface FormTimeInputProps extends FieldProps<FormControl<string> | FormControl<string | null>> {
  onChange?(date: string | null): void;
  withoutGroup?: boolean;
  asterisk?: boolean;
  options?: Partial<TimePickerProps>;
  clearable?: boolean;
}

export function FormTimeInput(props: FormTimeInputProps) {
  const { formControl, fieldState, fieldConfig } = useFormField(props);

  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = fieldState.value ? dayjs(fieldState.value, 'H:mm') : null;
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const fieldReadonly = fieldConfig.readonly || false;
  const fieldDisabled = fieldConfig.disabled || false;

  const fieldPlaceholder = fieldConfig.placeholder || 'mm/dd/yyyy';

  const content = (
    <Fragment>
      {fieldConfig.label && (
        <Label for={formControl.uid}>
          {fieldConfig.label} {fieldConfig.required && props.asterisk && <span className="text-danger">*</span>}
        </Label>
      )}

      <TimePicker
        changeOnBlur
        use12Hours
        value={fieldValue}
        format="h:mm a"
        allowClear={props.clearable || false}
        {...props.options}
        popupStyle={{ zIndex: 9999 }}
        onChange={(value: dayjs.Dayjs) => {
          if (value) {
            formControl.setValue(value.format('HH:mm'));
            props.onChange && props.onChange(value.format('HH:mm'));
          } else {
            formControl.setValue(null);
            props.onChange && props.onChange(null);
          }
        }}
      />
      {!!fieldError && <FormHelperText style={{ color: '#f44336' }}>{fieldError}</FormHelperText>}
    </Fragment>
  );

  if (props.withoutGroup) {
    return <div className="theme_date-picker d-flex flex-column">{content}</div>;
  }

  return <FormGroup className="theme_date-picker d-flex flex-column">{content}</FormGroup>;
}
